import { useTranslation } from 'react-i18next';
import { Button, CopyField, ModalComponentWrapper } from '@/shared/components';
import {
  type TwoFactorAppCodeModalArgs,
  useTwoFactorSettingsModals,
} from '../model';
import { MFA_IDENTITY_TYPES } from '@/entities/mfa-identity';

const TwoFactorAuthAppCodeModal = ({
  code,
  uri,
  onBack,
  goToCurrentScreen,
  onSuccess,
  preventOverlayClose,
  showCloseButton,
}: TwoFactorAppCodeModalArgs) => {
  const { t } = useTranslation();
  const { openTwoFactorIdentityEnableModal } = useTwoFactorSettingsModals();
  const localePath =
    'personalAccount.userProfile.securityAndPrivacy.twoFactorAuthorization.twoFactorAuthAppCode';

  return (
    <ModalComponentWrapper
      title={t(`${localePath}.title`)}
      description={t(`${localePath}.description`)}
      onBack={onBack}
      headerClassName="text-secondary-bg bg-secondary-bg/50">
      <CopyField
        className={'w-full'}
        label={t(`${localePath}.fieldName`)}
        qrCodeData={uri}
        value={code}
      />
      <Button
        size="lg"
        onClick={() => {
          openTwoFactorIdentityEnableModal({
            identityType: MFA_IDENTITY_TYPES.GOOGLE_AUTHENTICATOR,
            appKey: code,
            onSuccess,
            onBack: goToCurrentScreen,
            showCloseButton,
            preventOverlayClose,
          });
        }}>
        {t('common.continue')}
      </Button>
    </ModalComponentWrapper>
  );
};

export { TwoFactorAuthAppCodeModal };
